import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";

import { DialogFooter } from "../../../components/DialogFooter";

interface ShiftCancelledWithoutClipboardScoreBottomSheetProps {
  modalState: UseModalState;
  onContinue: () => void;
}

export function ShiftCancelledWithoutClipboardScoreBottomSheet(
  props: ShiftCancelledWithoutClipboardScoreBottomSheetProps
) {
  const { modalState, onContinue } = props;

  return (
    <BottomSheet modalState={modalState}>
      <BottomSheetIllustrationContent illustrationType="cancellation" title="Shift cancelled" />
      <DialogFooter orientation="vertical" sx={{ marginTop: 10 }}>
        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={() => {
            modalState.closeModal();

            if (onContinue) {
              onContinue();
            }
          }}
        >
          Continue
        </Button>
      </DialogFooter>
    </BottomSheet>
  );
}
